import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ProductLogoMediumNetworks as LogoNetworks } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { useTranslation } from "@/lib/i18n";

export const Route = createFileRoute("/_staff/networks/_layout")({
  component: Layout,
});

function Layout() {
  const { t } = useTranslation();
  useDocumentTitle(t("pages.networks.list.pageTitle"));

  const tabs = [
    {
      to: "/networks/overview",
      children: t("common.list.overview"),
    },
    {
      to: "/networks",
      children: t("common.list.networks"),
      activeOptions: { exact: true, includeSearch: true },
    },
    { to: "/networks/alerts", children: t("common.list.alerts") },
    {
      to: "/networks/contract-and-cost",
      children: t("common.list.contractAndCost"),
    },
    {
      to: "/networks/operation-activity",
      children: t("common.list.operationActivity"),
    },
    {
      to: "/networks/rule-and-policy",
      children: t("common.list.ruleAndPolicy"),
    },
    { to: "/networks/settings", children: t("common.list.settings") },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={LogoNetworks}
        name={t("pages.networks.list.pageTitle")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
